<template>
    <div @click="show_mask" class="box" :style="`background-image:url(${img.bg})`">
        <div v-if="is_show" class="box_mask">
            <img :src="$config.SystemOS=='IOS'?renew_tips_ios:renew_tips_android" alt="">
        </div>

        <!-- 第一种 -->
        <div v-if="img.type==1" class="type_one">
            <div class="type_one_box">
                <img class="img1" :src="img.img" alt="">
                <img class="btn" :src="is_show?img.btn2:img.btn1" alt="">
            </div>
            <img class="footer" :src="img.footer" alt="">
        </div>
        <!-- 第二种 -->
        <img v-if="img.type==2" class="img2" :src="img.img" alt="">
    </div>
</template>
<script>
export default {
    name:'Welfare',
    data(){
        // 第一批 旺信通公众号客服消息优化
        const renew_tips_ios = this.$OSSBaseUrl + 'renew_tips_ios.png';
        const renew_tips_android = this.$OSSBaseUrl + 'renew_tips_android.png';
        const Welfare_2h_bg = this.$OSSBaseUrl + 'Welfare_2h_bg.png';
        const Welfare_2h_img = this.$OSSBaseUrl + 'Welfare_2h_img.png';
        const Welfare_6hAND24h_bg = this.$OSSBaseUrl + 'Welfare_6hAND24h_bg.png';
        const Welfare_6hAND24h_img = this.$OSSBaseUrl + 'Welfare_6hAND24h_img.png';
        const Welfare_6hAND24h_btn1 = this.$OSSBaseUrl + 'Welfare_6hAND24h_btn1.png';
        const Welfare_6hAND24h_btn2 = this.$OSSBaseUrl + 'Welfare_6hAND24h_btn2.png';
        const Welfare_6hAND24h_footer = this.$OSSBaseUrl + 'Welfare_6hAND24h_footer.png';
        const Welfare_8hAND16h_bg = this.$OSSBaseUrl + 'Welfare_8hAND16h_bg.png';
        const Welfare_8hAND16h_img = this.$OSSBaseUrl + 'Welfare_8hAND16h_img.png';
        const Welfare_8hAND16h_btn1 = this.$OSSBaseUrl + 'Welfare_8hAND16h_btn1.png';
        const Welfare_8hAND16h_btn2 = this.$OSSBaseUrl + 'Welfare_8hAND16h_btn2.png';
        const Welfare_8hAND16h_footer = this.$OSSBaseUrl + 'Welfare_8hAND16h_footer.png';
        const Welfare_12h_bg = this.$OSSBaseUrl + 'Welfare_12h_bg.png';
        const Welfare_12h_img = this.$OSSBaseUrl + 'Welfare_12h_img.png';
        const Welfare_36h_bg = this.$OSSBaseUrl + 'Welfare_36h_bg.png';
        const Welfare_36h_img = this.$OSSBaseUrl + 'Welfare_36h_img.png';
        // 第二批 过期用户模板消息/续费成功模板消息
        // 90天微信消息
        const Welfare_bg = this.$OSSBaseUrl + 'Welfare_bg.png';
        const Welfare_img = this.$OSSBaseUrl + 'Welfare_img.png';
        // 1200条短信
        const Welfare_bg1 = this.$OSSBaseUrl + 'Welfare_bg1.png';
        const Welfare_img1 = this.$OSSBaseUrl + 'Welfare_img1.png';
        // 300分钟通话
        const Welfare_bg2 = this.$OSSBaseUrl + 'Welfare_bg2.png';
        const Welfare_img2 = this.$OSSBaseUrl + 'Welfare_img2.png';
        // 老客户专属福利
        const Welfare_bg3 = this.$OSSBaseUrl + 'Welfare_bg3.png';
        const Welfare_img3 = this.$OSSBaseUrl + 'Welfare_img3.png';
        // 99元优惠券
        const Welfare_bg4 = this.$OSSBaseUrl + 'Welfare_bg4.png';
        const Welfare_img4 = this.$OSSBaseUrl + 'Welfare_img4.png';
        // 1000万补贴
        const Welfare_bg5 = this.$OSSBaseUrl + 'Welfare_bg5.png';
        const Welfare_img5 = this.$OSSBaseUrl + 'Welfare_img5.png';
        // 51元特惠
        const Welfare_bg6 = this.$OSSBaseUrl + 'Welfare_bg6.png';
        const Welfare_img6 = this.$OSSBaseUrl + 'Welfare_img6.png';

        let is_show=false
        let img={}
        // a~h
        switch (this.$route.query.dayhour) {
            case '6h':
                img = {
                    bg: Welfare_6hAND24h_bg,
                    img: Welfare_6hAND24h_img,
                    btn1: Welfare_6hAND24h_btn1,
                    btn2: Welfare_6hAND24h_btn2,
                    footer: Welfare_6hAND24h_footer,
                    type: 1,
                }
                break;
            case '8h':
                img = {
                    bg: Welfare_8hAND16h_bg,
                    img: Welfare_8hAND16h_img,
                    btn1: Welfare_8hAND16h_btn1,
                    btn2: Welfare_8hAND16h_btn2,
                    footer: Welfare_8hAND16h_footer,
                    type: 1,
                }
                is_show = true
                break;
            case '16h':
                img = {
                    bg: Welfare_8hAND16h_bg,
                    img: Welfare_8hAND16h_img,
                    btn1: Welfare_8hAND16h_btn1,
                    btn2: Welfare_8hAND16h_btn2,
                    footer: Welfare_8hAND16h_footer,
                    type: 1,
                }
                break;
            case '24h':
                img = {
                    bg: Welfare_6hAND24h_bg,
                    img: Welfare_6hAND24h_img,
                    btn1: Welfare_6hAND24h_btn1,
                    btn2: Welfare_6hAND24h_btn2,
                    footer: Welfare_6hAND24h_footer,
                    type: 1,
                }
                break;
            case '2h':
                img = {
                    bg: Welfare_2h_bg,
                    img: Welfare_2h_img,
                    type: 2,
                }
                is_show = true
                break;
            case '12h':
                img = {
                    bg: Welfare_12h_bg,
                    img: Welfare_12h_img,
                    type: 2,
                }
                is_show = true
                break;
            case '36h':
                img = {
                    bg: Welfare_36h_bg,
                    img: Welfare_36h_img,
                    type: 2,
                }
                is_show = true
                break;
            default:
                break;
        }
        // workType
        switch (this.$route.query.workType) {
            // 90天微信消息
            case 'type1':
                img = {
                    bg: Welfare_bg,
                    img: Welfare_img,
                    type: 2,
                }
                is_show = true
                break;
            // 1200条短信
            case 'type2':
                img = {
                    bg: Welfare_bg1,
                    img: Welfare_img1,
                    type: 2,
                }
                is_show = true
                break;
            // 300分钟通话
            case 'type3':
                img = {
                    bg: Welfare_bg2,
                    img: Welfare_img2,
                    type: 2,
                }
                is_show = true
                break;
               
             // 51元特惠
            case 'type4':
                img = {
                    bg:  Welfare_bg6,
                    img: Welfare_img6,
                    type: 2,
                }
                is_show = true
                break;
            default:
                break;
        }
        return{
            img,
            is_show,
            renew_tips_ios,
            renew_tips_android,
        }
    },
    mounted(){
        let data = {
            page_from:'main_page',
            page_name:'Welfare',
            page_time:'0.00',
            receiver_id: '',
            page_param:this.$route.query.dayhour ? {dayhour:this.$route.query.dayhour} : {workType:this.$route.query.workType},
        };
        this.$store.dispatch('Public/inH5Record', data)
    },
    methods:{
        show_mask(){
            this.is_show = true
        }
    }
}
</script>
<style lang="scss" scoped>
    @import 'index.scss';
</style>
